// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31zLF","fullView":"styles_fullView__2GH2N"};